<script>
import NavbarComponent from './components/Navbar.vue';
export default {
  name: 'App',
  components: { NavbarComponent }
}
</script>

<template>
  <div id="app">
    <!-- <NavbarComponent /> -->
    <notifications group="foo" />
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-md-12">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>


// WEBPACK FOOTER //
// src/App.vue